import gsap from 'gsap'

class Marquee {

  constructor() {
    this.marquees = document.querySelectorAll('.c-marquee')
    console.log(this.marquees)

    this.marquees.forEach((marquee) => {
      marquee.classList.add('is-enabled')
      const timelines = []

      const inner = marquee.querySelector('.c-marquee__inner')
      if (inner.offsetWidth < marquee.offsetWidth * 2) {
        const multiplier = Math.ceil(marquee.offsetWidth / inner.offsetWidth) * 2
        const children = [...inner.children]

        for (let i = 0; i < multiplier; i += 1) {
          const clones = []
          children.forEach((child) => {
            const clone = child.cloneNode(true)
            clones.push(clone)
          })
          inner.append(...clones)
        }
      }

      const spans = marquee.querySelectorAll('.c-marquee__inner span')
      const duration = inner.offsetWidth / 120

      spans.forEach((span, i) => {
        const { offsetLeft, offsetWidth } = span
        timelines[i] = gsap.timeline()
          .to(span, {
            duration,
            ease: 'none',
            x: () => `-=${inner.offsetWidth}px`,
            modifiers: {
              x(x) {
                const wrap = gsap.utils.unitize(
                  gsap.utils.wrap(
                    0 - offsetLeft - offsetWidth,
                    inner.offsetWidth - offsetLeft - offsetWidth,
                  ),
                  'px',
                )
                return wrap(x)
              },
            },
            repeat: -1,
          })
      })

    })
  }
}

export default Marquee
